(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.category-slider').slick({
    slidesToShow: 5,
    arrows: true,
  //  variableWidth: true,
infinite: false,
    prevArrow: '<button type="button" class="slick-prev custom-prev"><svg viewBox="0 0 20 20" width="20" height="20"><path d="M13 15l-5-5 5-5" stroke="white" stroke-width="2" fill="none"/></svg></button>',
nextArrow: '<button type="button" class="slick-next custom-next"><svg viewBox="0 0 20 20" width="20" height="20"><path d="M7 5l5 5-5 5" stroke="white" stroke-width="2" fill="none"/></svg></button>',
    responsive: [
      { breakpoint: 1024, settings: {
         slidesToShow: 5,
         slidesToScroll: 1,
         variableWidth: true,
         rows: 2
       } },
      { breakpoint: 768, settings: { 
        slidesToShow: 3, 
        slidesToScroll: 1,
        variableWidth: true,
        rows: 2
      } },
      { breakpoint: 480, settings: { 
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        rows: 2 
    } }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpllection-with-price"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.category-slider1').slick( {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    variableWidth:true,
    swipe: true,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev custom-prev"><svg viewBox="0 0 20 20" width="20" height="20"><path d="M13 15l-5-5 5-5" stroke="white" stroke-width="2" fill="none"/></svg></button>',
nextArrow: '<button type="button" class="slick-next custom-next"><svg viewBox="0 0 20 20" width="20" height="20"><path d="M7 5l5 5-5 5" stroke="white" stroke-width="2" fill="none"/></svg></button>',
    responsive: [
      { breakpoint: 1024, settings: {
         slidesToShow: 3,
         variableWidth:true,
       } },
      { breakpoint: 768, settings: { 
        slidesToShow: 3,
        variableWidth:true,
      } },
      { breakpoint: 480, settings: { 
        slidesToShow: 3,
        variableWidth:true,
    } }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
